const composers = [
  {
    composerName: "Sam Loyd",
    composerImg: "Loyd.jpg",
    composerId: "0",
    composerInfo:
      "Samuel Loyd (January 30, 1841 – April 10, 1911) was an American chess player, chess composer, puzzle author, and recreational mathematician. Loyd was born in Philadelphia but raised in New York City. He is considered one of America's greatest puzzle makers and popularizers.",
  },
  {
    composerName: "Vladimir Nabokov",
    composerImg: "nabokov.jpeg",
    composerId: "1",
    composerInfo:
      "Vladimir Nabokov (April 22, 1899 – July 2, 1977) was a Russian-American novelist, poet, translator, and entomologist. He is best known for his novel 'Lolita' (1955). Nabokov also composed chess problems, including the famous 'Poet's Mate'.",
  },
  {
    composerName: "Otto Blathy",
    composerImg: "Otto.jpg",
    composerId: "2",
    composerInfo:
      "Ottó Titusz Bláthy (August 11, 1860 – September 26, 1939) was a Hungarian engineer, inventor, and chess composer. Bláthy is known for his contributions to chess problems, particularly in the genre of long-movers, or problems involving a large number of moves.",
  },
  {
    composerName: "François-André Danican Philidor",
    composerImg: "Philidor.jpg",
    composerId: "3",
    composerInfo:
      "François-André Danican Philidor (September 7, 1726 – August 31, 1795) was a French composer and chess player. He is considered one of the best chess players of his age and is best known for his book 'Analyse du jeu des Échecs' published in 1749.",
  },
  {
    composerName: "Alexey Troitzky",
    composerImg: "Troitzky.jpg",
    composerId: "4",
    composerInfo:
      "Alexey Troitzky (March 14, 1866 – August 1942) was a Russian chess theoretician who is widely regarded as the founder of the modern art of composing chess endgame studies. His work had a profound impact on chess composition.",
  },
  {
    composerName: "Edith Baird",
    composerImg: "BairdEdith-2.jpg",
    composerId: "5",
    composerInfo:
      "Edith Baird (1859 – 1924) was an English chess composer and author. She was one of the most prolific female composers of chess problems and contributed to the popularization of chess composition through her numerous publications.",
  },
  {
    composerName: "Pal Benko",
    composerImg: "benko.jpg",
    composerId: "6",
    composerInfo:
      "Pál Benkő (July 15, 1928 – August 26, 2019) was a Hungarian-American chess player and problemist. He was an International Grandmaster and one of the leading chess players in the mid-20th century. Benko is also known for his contributions to chess problems and endgame studies.",
  },
  {
    composerName: "Comins Mansfield",
    composerImg: "Comins_Mansfield_1.png",
    composerId: "7",
    composerInfo:
      "Comins Mansfield (June 14, 1896 – March 28, 1984) was a British chess problem composer. He was awarded the title of International Grandmaster for Chess Compositions in 1972 and is considered one of the greatest composers of the two-move chess problem.",
  },
  {
    composerName: "Henri Rinck",
    composerImg: "HenriRinck.jpg",
    composerId: "8",
    composerInfo:
      "Henri Rinck (January 10, 1870 – February 17, 1952) was a French chess problem composer and endgame study theorist. Rinck published several books on endgame studies and is renowned for his contributions to the field of chess composition.",
  },
  {
    composerName: "Ferenc Erkel",
    composerImg: "Erkel_Ferenc_Györgyi_Alajos.jpg",
    composerId: "9",
    composerInfo:
      "Ferenc Erkel (November 7, 1810 – June 15, 1893) was a Hungarian composer and chess player. He is regarded as one of the pioneers of chess in Hungary and composed many chess problems in addition to his contributions to Hungarian music.",
  },
  {
    composerName: "Richard Réti",
    composerImg: "reti.png",
    composerId: "10",
    composerInfo:
      "Richard Réti (May 28, 1889 – June 6, 1929) was an Austro-Hungarian, later Czechoslovakian, chess player, chess composer, and chess author. He was one of the most prominent figures in chess history and a leading figure in the hypermodern school of chess.",
  },
];

export { composers };
